<template>
	<div>
		<!--<div class="reportStatistics" v-show="userParameter.ExpertFromType==4">
			<div>到目前为止共计完成质控报告 : <span>{{expertJobCountList.TotalCount}}</span> 例 <i></i> 本月总质控报告数量 : <span>{{expertJobCountList.CurrentMonthCount}}</span>例</div>
		</div>-->
		<template v-if="userParameter.ExpertFromType==4">
			<el-table class="qcTable" :data="expertJobCountList.Months" v-loading="loading">
				<el-table-column prop="Name" label="姓名"></el-table-column>
				<el-table-column prop="Count" label="工作量"></el-table-column>
			</el-table>
		</template>
	</div>
</template>

<script>
	import { mapState, mapActions, mapMutations } from 'vuex'
	export default {
		computed: {
			...Vuex.mapState('managerUser', ['getUserlist', 'userParameter', 'expertJobCountList','loading'])
		},
		methods: {
			// ...Vuex.mapMutations('managerUser', ['setSplitScreen']),
			// ...Vuex.mapActions('managerUser', ['ExpertInfoDelete']),
		}

	}
</script>